module.exports = __webpack_public_path__ + "assets/re_enrolment.2c500e839a10c6424008c2364be1548c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/re_enrolment.jpg
// module id = 621
// module chunks = 0